import React from 'react';
import { ProductKey } from 'src/shared/types/engine/products';

/**
 * The product that guards the page. `StandardAppLayout` reads it to tell
 * internal staff what the customer does not see. `undefined` outside a gate.
 *
 * In its own file, not in `ProductGate`: the layout reads it, and the gate
 * renders `PageNotFound`, which renders the layout.
 */
export const GatedProductContext = React.createContext<ProductKey | undefined>(undefined);
